export const COOKIE_KEYS = {
    USER: 'user',
    DOMAIN: 'domain',
    BRANCH_IDS: 'branch_ids',
    PROMOTION_SUB_MENU_CONFIG: 'promotion_sub_menu_config',
    CURRENT_PROMOTION_SUB_MENU_CONFIG: 'current_promotion_sub_menu_config',
};